import { readable } from "svelte/store";
function getLangFromHtml() {
    const raw = document.documentElement.lang;
    if (raw.startsWith("cs"))
        return "cs";
    if (raw.startsWith("en"))
        return "en";
    return "cs";
}
export const currentLang = readable(getLangFromHtml());
